import React from 'react';

export default function SettingsIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M12 9.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Z" fill="currentColor" />
      <path
        d="M19.4 15a1.7 1.7 0 0 0 .33 1.87l.04.04a2 2 0 1 1-2.83 2.83l-.04-.04a1.7 1.7 0 0 0-1.87-.33 1.7 1.7 0 0 0-1.03 1.55V22a2 2 0 1 1-4 0v-.08a1.7 1.7 0 0 0-1.03-1.55 1.7 1.7 0 0 0-1.87.33l-.04.04a2 2 0 1 1-2.83-2.83l.04-.04a1.7 1.7 0 0 0 .33-1.87 1.7 1.7 0 0 0-1.55-1.03H2a2 2 0 1 1 0-4h.08a1.7 1.7 0 0 0 1.55-1.03 1.7 1.7 0 0 0-.33-1.87l-.04-.04a2 2 0 1 1 2.83-2.83l.04.04a1.7 1.7 0 0 0 1.87.33 1.7 1.7 0 0 0 1.03-1.55V2a2 2 0 1 1 4 0v.08a1.7 1.7 0 0 0 1.03 1.55 1.7 1.7 0 0 0 1.87-.33l.04-.04a2 2 0 1 1 2.83 2.83l-.04.04a1.7 1.7 0 0 0-.33 1.87 1.7 1.7 0 0 0 1.55 1.03H22a2 2 0 1 1 0 4h-.08a1.7 1.7 0 0 0-1.55 1.03Z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
